import { render, staticRenderFns } from "./StandardDynamicForm.vue?vue&type=template&id=4d1a0aa8&"
import script from "./StandardDynamicForm.vue?vue&type=script&lang=js&"
export * from "./StandardDynamicForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports